<ng-container *ngIf="video.videoPlatform === 'vimeo'">
  <video
    preload="metadata"
    controlsList="nodownload"
    [src]="(video.vimeoId ? (video.vimeoId | vimeoPlayableUrl | async) : video.videoUrl) + '#t=0.5'"
    (loadstart)="onVideoLoadStart()"
    (canplay)="onVideoCanPlay()"
    (error)="videoErrorLoad($event)"
    [attr.controls]="controls ? true : null"
    [attr.autoplay]="autoplay ? true : null"
    [attr.playsinline]="autoplay ? true : null"
    loop
    muted
   >
  </video>
</ng-container>

<ng-container *ngIf="video.videoPlatform === 'apiDotVideo'">
  <video
    preload="metadata"
    controlsList="nodownload"
    [src]="video.videoUrl + '#t=0.5'"
    (loadstart)="onVideoLoadStart()"
    (canplay)="onVideoCanPlay()"
    (error)="videoErrorLoad($event)"
    [attr.controls]="controls ? true : null"
    [attr.autoplay]="autoplay ? true : null"
    [attr.playsinline]="autoplay ? true : null"
    loop
    muted>
  </video>
</ng-container>
